import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { sectionTitleSx } from '../../styles/typography';

// A thin panel header: a small bold title (the panel's description sits behind
// an info icon) on the left, then optional inline controls such as filter
// chips, and compact icon actions on the right.
export const compactPanelHeaderSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    minHeight: 28,
    mb: 0.5,
    flexWrap: 'wrap',
    minWidth: 0,
};

export const compactPanelTitleSx = {
    ...sectionTitleSx,
    color: 'text.primary',
    fontWeight: 800,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
};

const actionClusterSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 0.5,
    ml: 'auto',
    flexWrap: 'wrap',
    minWidth: 0,
};

export default function CompactPanelHeader({
    title,
    description = null,
    leading = null,
    children = null,
    sx = null,
}) {
    return (
        <Box sx={[compactPanelHeaderSx, ...(Array.isArray(sx) ? sx : [sx])]}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4 }}>
                    <Typography variant="subtitle1" sx={compactPanelTitleSx}>
                        {title}
                    </Typography>
                    {description && (
                        <Tooltip title={description} arrow>
                            <InfoOutlinedIcon
                                aria-label={description}
                                sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }}
                            />
                        </Tooltip>
                    )}
                </Box>
                {leading}
            </Box>
            {children && <Box sx={actionClusterSx}>{children}</Box>}
        </Box>
    );
}

CompactPanelHeader.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.string,
    leading: PropTypes.node,
    children: PropTypes.node,
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
